import FolderIcon from '@mui/icons-material/Folder';
import PublicIcon from '@mui/icons-material/Public';
import TableChartIcon from '@mui/icons-material/TableChart';
import ArchiveIcon from '@mui/icons-material/Archive';

export const EXPORT_FORMATS = [
  {
    key: "geojson",
    label: "GeoJSON",
    icon: <FolderIcon style={{ fontSize: 18 }} />,
  },
  {
    key: "kml",
    label: "KML",
    icon: <FolderIcon style={{ fontSize: 18 }} />,
  },
  // {
  //   key: "csv",
  //   label: "CSV",
  //   icon: <TableChartIcon style={{ fontSize: 18 }} />,
  // },
  {
    key: "shp",
    label: "Shapefile",
    icon: <FolderIcon style={{ fontSize: 18 }} />,
  },
];